import type {
  WishlistDetailsContent,
  WishlistUnit,
} from '@/domains/proB2BServices/Wishlists/interfaces';

export const getOneMapper = (data: any): WishlistUnit => {
  const { content } = data;
  return {
    id: content.id,
    isBasket: content.id === 'cart',
    readOnly: content.read_only,
    productCount: content.product_count,
    createdAt: content.created_at,
    updatedAt: content.updated_at,
    name: content.name,
  };
};

// mappers
export const getAllMapper = (data?: any): WishlistUnit[] =>
  data?.content
    .map((wishlistUnit: any) => ({
      id: wishlistUnit.id,
      isBasket: wishlistUnit.id === 'cart',
      readOnly: wishlistUnit.read_only,
      productCount: wishlistUnit.product_count,
      createdAt: wishlistUnit.created_at,
      updatedAt: wishlistUnit.updated_at,
      name: wishlistUnit.name,
    }))
    .sort((wu: WishlistUnit) => (wu.id === 'cart' ? -1 : 0));

export const getOneDetailMapper = (data?: any): WishlistDetailsContent => ({
  name: data?.content.name,
  readOnly: data?.content.read_only,
  productCount: data?.content.product_count,
  createdAt: data?.content.created_at,
  updatedAt: data?.content.updated_at,
  id: data?.content.id,
  isBasket: data?.content.id === 'cart',
  products: data?.content.products.map((wishlistProduct: any) => ({
    id: wishlistProduct.id,
    articleId: wishlistProduct.article_id,
    modelId: wishlistProduct.model_id,
    name: wishlistProduct.name,
    image: wishlistProduct.image,
    link: wishlistProduct.link,
    reference: wishlistProduct.reference,
    price: {
      perUnit: wishlistProduct.price.per_unit,
      total: wishlistProduct.price.total,
      totalExcludingVat: wishlistProduct.price.totalExcludingVat,
    },
    rating: {
      count: wishlistProduct.rating.count,
      average: wishlistProduct.rating.average,
    },
    quantity: wishlistProduct.quantity,
    sellable: wishlistProduct.sellable,
    category: wishlistProduct.category,
    categoryUrl: wishlistProduct.category_url,
    isB2b: wishlistProduct.is_b2b,
    hasProConditions: wishlistProduct.has_pro_conditions,
    unavailibityReason: wishlistProduct.unavailibity_reason,
  })),
  itemsNotAvailable: {
    sellerOptOut: data?.content.items_not_available?.seller_opt_out,
    outOfStock: data?.content.items_not_available?.out_of_stock,
  },
});
